import React from 'react';

import Header from './header';

export default class LayoutWithHeader extends React.Component {
  render() {
    let { children, logo } = this.props;
    return (
      <div className="login animated fadeInDown bg-white">
        <Header logo={logo} />
        <div className="main" role="main">
          {children}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/layoutWithHeader.js